import React from "react";
import styled from "styled-components";
import {
  Card,
  CardContent,
  CardHeaderTextTitle,
  CardHeader,
  CardHeaderCategory,
} from "../../organisms/dashboard/Card";
import { useExisteListaAsistenciaDeHoy } from "../../../services/asistenciaServicios";
import TablaAsistenciaDiaria from "./TablaAsistenciaDiaria";

function SeccionTablaAsistenciaDiaria() {
  const { data: existeListaDeHoy, isSuccess: existeListaDeHoyIsSuccess } =
    useExisteListaAsistenciaDeHoy();

  return (
    <div className="col-lg-7 col-md-12">
      <TableCard className="card">
        <CardHeader className="card-header card-header-text">
          <CardHeaderTextTitle className="card-title">
            Asistencia diaria
          </CardHeaderTextTitle>
          <CardHeaderCategory className="category">
            {existeListaDeHoyIsSuccess && existeListaDeHoy && (
              <>Mascotas ingresadas el día de hoy</>
            )}
            {!existeListaDeHoyIsSuccess ||
              (!existeListaDeHoy && (
                <>No hay lista de asistencia para el día de hoy</>
              ))}
          </CardHeaderCategory>
        </CardHeader>
        <CardContent className="card-content table-responsive">
          {existeListaDeHoyIsSuccess && existeListaDeHoy && (
            <TablaAsistenciaDiaria />
          )}
        </CardContent>
      </TableCard>
    </div>
  );
}

const TableCard = styled(Card)`
  min-height: 300px;
`;

export default SeccionTablaAsistenciaDiaria;
